<template>
  <dc-layout-content>
    <div class="top-box">
      <div class="title">业务参数详情</div>
      <a-button type="primary" class="btn">业务参数</a-button>
    </div>
    <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" ref="tableRef">
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'action'">
          <more-button>
            <a-button type="link" @click="addEdit(record)">编辑</a-button>
            <a-button type="link" @click="deleteRow(record)">删除</a-button>
          </more-button>
        </template>
      </template>
    </cos-table>
  </dc-layout-content>
</template>
<script lang="ts">
import Modal from '@/hooks/modalType'
import { reactive, onMounted, ref } from 'vue'
import { listByParamCodes } from '@/api/common'
import { potentialList } from '@/api/overseasSales/customerCenter'

import { CustomerCode } from '@/typings/api/customerCenter'
export default { name: 'list' }
</script>
<script setup lang="ts">
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: CustomerCode) => void }>()

const tableRef = ref()
const queryForm = reactive({
  name: ''
})

onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_grade', 'zbu_partner_nature', 'zbu_main_customers', 'zbu_campaign_type', 'zbu_partner_role']
  }).then((res) => {
    if (res.code === 200) {
      console.log(11)
    }
  })
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  potentialList(params).then((res) => {
    callBack(res)
  })
}
// const success = () => {
//   tableRef.value.fetch()
// }
const columns = ref([
  { title: '业务参数', dataIndex: 'noset' },
  { title: '关联参数', dataIndex: 'noset' },
  {
    title: '状态',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: CustomerCode) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: CustomerCode) => {
  Modal.delete({
    name: row.arkCode,
    onOk() {
      tableRef.value?.delFetch()
      console.log(1)
    }
  })
}
</script>

<style lang="scss" scoped>
.top-box {
  position: relative;
  margin-bottom: 36px;
  .btn {
    position: absolute;
    top: 0;
    right: 0;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }
}
</style>
